export default "__VITE_ASSET__23990f3f__"